import React from "react";

/**
 * Navigation tips. variant="floating" overlays the graph (default).
 */
const TipsPanel = ({ showNavTips, onClose, tone = "dark", variant = "floating" }) => {
  if (!showNavTips) return null;

  const isLight = tone === "light";
  const isInline = variant === "inline";

  const shellClass = isInline
    ? isLight
      ? "shrink-0 border-b border-slate-200 bg-slate-50 px-3 py-3 md:px-4 max-h-[min(40vh,320px)] overflow-y-auto z-[5]"
      : "shrink-0 border-b border-gray-700 bg-gray-900/60 px-3 py-3 md:px-4 max-h-[min(40vh,320px)] overflow-y-auto z-[5]"
    : isLight
      ? "fixed inset-x-0 bottom-0 z-30 max-h-[70dvh] overflow-y-auto rounded-t-2xl border border-slate-200 bg-white p-4 pb-[max(1rem,env(safe-area-inset-bottom))] shadow-2xl md:absolute md:inset-x-auto md:top-4 md:right-4 md:bottom-auto md:z-20 md:max-h-[min(70vh,28rem)] md:max-w-sm md:w-[min(22rem,calc(100%-2rem))] md:rounded-lg md:pb-4 md:shadow-lg"
      : "fixed inset-x-0 bottom-0 z-30 max-h-[70dvh] overflow-y-auto rounded-t-2xl border border-gray-600 bg-gray-800 p-4 pb-[max(1rem,env(safe-area-inset-bottom))] shadow-2xl md:absolute md:inset-x-auto md:top-4 md:right-4 md:bottom-auto md:z-20 md:max-h-[min(70vh,28rem)] md:max-w-sm md:w-[min(22rem,calc(100%-2rem))] md:rounded-lg md:pb-4 md:shadow-lg";

  const headingClass = isLight ? "text-sm font-semibold text-slate-800" : "text-sm text-gray-300 font-bold";
  const bodyClass = isLight ? "space-y-3 text-sm text-slate-700" : "space-y-3 text-sm text-gray-300";
  const strongClass = isLight ? "font-semibold text-slate-900 mb-1" : "font-semibold text-white mb-1";
  const closeClass = isLight
    ? "text-slate-500 hover:text-slate-800 transition-colors shrink-0"
    : "text-gray-400 hover:text-white transition-colors shrink-0";

  return (
    <div className={shellClass}>
      <div className="flex items-center justify-between mb-3 gap-2">
        <div className={headingClass}>Navigation tips</div>
        <button
          type="button"
          onClick={onClose}
          className={closeClass}
          aria-label="Close tips panel"
        >
          ✕
        </button>
      </div>

      <div className={bodyClass}>
        <div className="md:hidden">
          <div className={strongClass}>Touch</div>
          <ul className="space-y-1 ml-2 list-disc list-inside">
            <li>
              <strong>Drag:</strong> Pan the graph
            </li>
            <li>
              <strong>Pinch:</strong> Zoom in or out
            </li>
            <li>
              <strong>Tap node:</strong> Entity details
            </li>
            <li>
              <strong>Tap edge:</strong> Relationship details
            </li>
          </ul>
        </div>

        <div className="hidden md:block">
          <div className={strongClass}>Mouse</div>
          <ul className="space-y-1 ml-2 list-disc list-inside">
            <li>
              <strong>Click &amp; drag:</strong> Pan the graph
            </li>
            <li>
              <strong>Scroll:</strong> Zoom in or out
            </li>
            <li>
              <strong>Click node:</strong> Entity details
            </li>
            <li>
              <strong>Click edge:</strong> Relationship details
            </li>
          </ul>
        </div>

        <div className="hidden md:block">
          <div className={strongClass}>Keyboard</div>
          <ul className="space-y-1 ml-2 list-disc list-inside">
            <li>
              <strong>Space:</strong> Reset layout
            </li>
            <li>
              <strong>F:</strong> Fit to view
            </li>
            <li>
              <strong>+ / −:</strong> Zoom in or out
            </li>
          </ul>
        </div>

        <div>
          <div className={strongClass}>Toolbar</div>
          <ul className="space-y-1 ml-2 list-disc list-inside">
            <li>
              <strong>Reset:</strong> Restart force simulation
            </li>
            <li>
              <strong>Filter:</strong> Show or hide entity types
            </li>
          </ul>
        </div>

        <div>
          <div className={strongClass}>Visual</div>
          <ul className="space-y-1 ml-2 list-disc list-inside">
            <li>Circles: entities (by type)</li>
            <li>Lines: relationships</li>
            <li>Hover: highlight connections</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TipsPanel;
